<template>
  <div>
    <b-container fluid>
      <h1>設定ファイル</h1>
      <b-form-group :label="this.translate['retry_interval']" label-cols="3" label-for="retry_interval" label-align="left" required>
        <b-form-input id="retry_interval" v-model="payload.retry_interval" :state="retryIntervalValidater" number></b-form-input>
        <b-form-invalid-feedback id="retry_interval" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['max_retry_count']" label-cols="3" label-for="max_retry_count" label-align="left" required>
        <b-form-input id="max_retry_count" v-model="payload.max_retry_count" :state="maxRetryCountValidater" number></b-form-input>
        <b-form-invalid-feedback id="max_retry_count" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['buffer_oc_a']" label-cols="3" label-for="buffer_OC_A" label-align="left" required>
        <b-form-input id="buffer_OC_A" v-model="payload.buffer.OC_A" :state="bufferOcAValidater" number></b-form-input>
        <b-form-invalid-feedback id="buffer_OC_A" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['buffer_oc_it']" label-cols="3" label-for="buffer_OC_IT" label-align="left" required>
        <b-form-input id="buffer_OC_IT" v-model="payload.buffer.OC_IT" :state="bufferOcItValidater" number></b-form-input>
        <b-form-invalid-feedback id="buffer_OC_IT" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['buffer_ic_a']" label-cols="3" label-for="buffer_IC_A" label-align="left" required>
        <b-form-input id="buffer_IC_A" v-model="payload.buffer.IC_A" :state="bufferIcAValidater" number></b-form-input>
        <b-form-invalid-feedback id="buffer_IC_A" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['buffer_ic_ma']" label-cols="3" label-for="buffer_IC_MA" label-align="left" required>
        <b-form-input id="buffer_IC_MA" v-model="payload.buffer.IC_MA" :state="bufferIcMaValidater" number></b-form-input>
        <b-form-invalid-feedback id="buffer_IC_MA" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['buffer_ic_it']" label-cols="3" label-for="buffer_IC_IT" label-align="left" required>
        <b-form-input id="buffer_IC_IT" v-model="payload.buffer.IC_IT" :state="bufferIcItValidater" number></b-form-input>
        <b-form-invalid-feedback id="buffer_IC_IT" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['buffer_rc_ma']" label-cols="3" label-for="buffer_RC_MA" label-align="left" required>
        <b-form-input id="buffer_RC_MA" v-model="payload.buffer.RC_MA" :state="bufferRcMaValidater" number></b-form-input>
        <b-form-invalid-feedback id="buffer_RC_MA" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['buffer_adp_it']" label-cols="3" label-for="buffer_ADP_IT" label-align="left" required>
        <b-form-input id="buffer_ADP_IT" v-model="payload.buffer.ADP_IT" :state="bufferAdpItValidater" number></b-form-input>
        <b-form-invalid-feedback id="buffer_ADP_IT" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['err_a']" label-cols="3" label-for="err_a" label-align="left" required>
        <b-form-input id="err_a" v-model="payload.err.A" :state="errAValidater" number></b-form-input>
        <b-form-invalid-feedback id="err_a" class="text-left">0以上の数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['err_ma']" label-cols="3" label-for="err_ma" label-align="left" required>
        <b-form-input id="err_ma" v-model="payload.err.MA" :state="errMaValidater" number></b-form-input>
        <b-form-invalid-feedback id="err_ma" class="text-left">0以上の数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['err_it']" label-cols="3" label-for="err_it" label-align="left" required>
        <b-form-input id="err_it" v-model="payload.err.IT" :state="errItValidater" number></b-form-input>
        <b-form-invalid-feedback id="err_it" class="text-left">0以上の数を入力してください</b-form-invalid-feedback>
      </b-form-group>
      <b-form-group :label="this.translate['simulation_time']" label-cols="3" label-for="simulation_time" label-align="left" required>
        <b-form-input id="simulation_time" v-model="payload.simulation_time" :state="simulationTimeValidater" number></b-form-input>
        <b-form-invalid-feedback id="simulation_time" class="text-left">0以上の整数を入力してください</b-form-invalid-feedback>
      </b-form-group>
    </b-container>
    <b-row align-h="center">
      <template >
        <b-button
          variant="outline-secondary"
          @click="submitTrafficConfig"
        >保存</b-button>
      </template>
      <template >
        <b-button
          variant="outline-secondary"
          @click="downloadsCSV"
        >DL</b-button>
      </template>
      <button
        @click="displayResumeModal = !displayResumeModal"
        class="btn btn-outline-secondary"
      >戻る</button>
      <b-modal
        v-model="displayResumeModal"
        hide-footer
      >
        <b-row align-h="around">
          <p>移動してよろしいですか？</p>
        </b-row>
        <b-row align-h="around">
          <button
            class="btn btn-outline-secondary"
            @click="pageBack"
          >はい</button>
          <button
            class="btn btn-outline-secondary"
            @click="displayResumeModal = !displayResumeModal"
          >いいえ</button>
        </b-row>
      </b-modal>
    </b-row>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
export default {
  name: 'TrafficConfig',
  data () {
    return {
      payload: {
        retry_interval: 0,
        max_retry_count: 0,
        buffer: {
          OC_A: 0,
          OC_IT: 0,
          IC_A: 0,
          IC_MA: 0,
          IC_IT: 0,
          RC_MA: 0,
          ADP_IT: 0
        },
        err: {
          A: 0,
          MA: 0,
          IT: 0
        },
        simulation_time: 0
      },
      displayResumeModal: false,
      isValid: false
    }
  },
  methods: {
    async submitTrafficConfig () {
      const parsedPayload = this.parsePayload(this.payload)
      const payload = JSON.stringify(parsedPayload).split('"').join('\\"')
      try {
        const res = await API.graphql(graphqlOperation(`
          mutation updateTrafficConfig {
            updateTrafficCalculatorConfig(
              config: "${payload}"
            ) {
              config
            }
          }
        `))
        this.$log.debug(res)
        this.makeToast('成功', '設定ファイルを保存しました', 'info')
      } catch (e) {
        this.$log.debug(e)
        this.makeToast('失敗', '設定ファイルの保存に失敗しました', 'danger')
      }
    },
    parsePayload (payload) {
      for (let key in payload) {
        if (key === 'buffer' || key === 'err') {
          for (let innerKey in payload[key]) {
            if (payload[key][innerKey] === 0) {
              delete payload[key][innerKey]
            }
          }
          if (payload[key] === 0) {
            delete payload[key]
          }
        }
      }
      return payload
    },
    checkPositiveInteger (val) {
      return Number.isInteger(Number(val)) && Number(val) >= 0
    },
    checkPositiveFloat (val) {
      return isFinite(Number(val)) && Number(val) >= 0
    },
    pageBack () {
      this.$router.go(-1)
    },
    async downloadsCSV () {
      let csv = '\ufeff'
      csv += `retry_interval,${this.payload.retry_interval}\n`
      csv += `max_retry_count,${this.payload.max_retry_count}\n`
      csv += `buffer_OC_A,${this.payload.buffer.OC_A}\n`
      csv += `buffer_OC_IT,${this.payload.buffer.OC_IT}\n`
      csv += `buffer_IC_A,${this.payload.buffer.IC_A}\n`
      csv += `buffer_IC_MA,${this.payload.buffer.IC_MA}\n`
      csv += `buffer_IC_IT,${this.payload.buffer.IC_IT}\n`
      csv += `buffer_RC_MA,${this.payload.buffer.RC_MA}\n`
      csv += `buffer_ADP_IT,${this.payload.buffer.ADP_IT}\n`
      csv += `err_a,${this.payload.err.A}\n`
      csv += `err_ma,${this.payload.err.MA}\n`
      csv += `err_it,${this.payload.err.IT}\n`
      csv += `simulation_time,${this.payload.simulation_time}`
      let blob = new Blob([csv], { type: 'text/csv' })
      let link = document.createElement('a')
      if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, 'Config.csv')
      } else {
        link.href = window.URL.createObjectURL(blob)
        link.download = 'Config.csv'
        link.click()
        this.all_loading = false
      }
    }
  },
  async created () {
    const skelton = {
      retry_interval: 0,
      max_retry_count: 0,
      buffer: {
        OC_A: 0,
        OC_IT: 0,
        IC_A: 0,
        IC_MA: 0,
        IC_IT: 0,
        RC_MA: 0,
        ADP_IT: 0
      },
      err: {
        A: 0,
        MA: 0,
        IT: 0
      }
    }
    const registeredData = await API.graphql(graphqlOperation(`
      query getTrafficConfig {
        getTrafficCalculatorConfig {
          config
        }
      }
    `))
    const payload = JSON.parse(registeredData.data.getTrafficCalculatorConfig.config)
    for (let key in payload) {
      if (key === 'buffer') {
        for (let bufferKey in payload[key]) {
          if (payload[key][bufferKey]) {
            skelton[key][bufferKey] = payload[key][bufferKey]
          }
        }
        continue
      }
      if (key === 'err') {
        for (let errKey in payload[key]) {
          skelton[key][errKey] = payload[key][errKey]
        }
        continue
      }
      skelton[key] = payload[key]
    }
    this.payload = JSON.parse(JSON.stringify(skelton))
  },
  computed: {
    retryIntervalValidater () {
      return this.checkPositiveInteger(this.payload.retry_interval)
    },
    maxRetryCountValidater () {
      return this.checkPositiveInteger(this.payload.max_retry_count)
    },
    bufferOcAValidater () {
      return this.checkPositiveInteger(this.payload.buffer.OC_A)
    },
    bufferOcItValidater () {
      return this.checkPositiveInteger(this.payload.buffer.OC_IT)
    },
    bufferIcAValidater () {
      return this.checkPositiveInteger(this.payload.buffer.IC_A)
    },
    bufferIcMaValidater () {
      return this.checkPositiveInteger(this.payload.buffer.IC_MA)
    },
    bufferIcItValidater () {
      return this.checkPositiveInteger(this.payload.buffer.IC_IT)
    },
    bufferRcMaValidater () {
      return this.checkPositiveInteger(this.payload.buffer.RC_MA)
    },
    bufferAdpItValidater () {
      return this.checkPositiveInteger(this.payload.buffer.ADP_IT)
    },
    errAValidater () {
      return this.checkPositiveFloat(this.payload.err.A)
    },
    errMaValidater () {
      return this.checkPositiveFloat(this.payload.err.MA)
    },
    errItValidater () {
      return this.checkPositiveFloat(this.payload.err.IT)
    },
    simulationTimeValidater () {
      return this.checkPositiveInteger(this.payload.simulation_time)
    }
  }
}
</script>
